"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedDirectDebit = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var components_1 = require("../../../../../../shared/core/components");
var money_1 = require("../../../../../../shared/core/utils/money");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var DirectDebitRecommendationMessage_1 = require("./DirectDebitRecommendationMessage");
var RecommendedDirectDebit = function (_a) {
    var directDebit = _a.directDebit, hasDirectDebit = _a.hasDirectDebit, recommendedDirectDebit = _a.recommendedDirectDebit;
    var currentDDAmount = directDebit.amount;
    return (
    // eslint-disable-next-line energy-cx/internal-events
    react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.RECOMMENDED_DD_SECTION, properties: !recommendedDirectDebit
            ? undefined
            : {
                hasDd: hasDirectDebit,
                balance: (0, money_1.getCurrencyValueAsNumber)({ unit: 'GBP' }, recommendedDirectDebit.balance),
                predictedFinalBalance: (0, money_1.getCurrencyValueAsNumber)({ unit: 'GBP' }, recommendedDirectDebit.predictedFinalBalance),
                ddRecState: recommendedDirectDebit.state,
                ownsDd: directDebit.customerOwnsMandate !== false,
            } }, !currentDDAmount ? null : (react_1.default.createElement(components_1.IconAndMessage, null,
        react_1.default.createElement(DirectDebitRecommendationMessage_1.DirectDebitRecommendationMessage, { recommendedDD: recommendedDirectDebit })))));
};
exports.RecommendedDirectDebit = RecommendedDirectDebit;
